import {Injectable} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators,} from '@angular/forms';
import {CustomValidators} from '../../../forms/validators';
import {FournisseurService} from '../../../modules/services/fournisseur/fournisseur.service';

@Injectable({
    providedIn: 'root',
})
export class InscriptionfournisseurFormService {
    fields = {
        capitale_social: 'capitalAmt',
        matricule_fiscale: 'taxId',
        categorie: 'corporationCl',
        name_soc: 'supplierNm',
        open_date: 'openYmd',
        Categorie_activite: 'bizCl',
        forme_jurdique: 'supplierCl',
        nbrempolye: 'employeeNum',
        adresse: 'addr1',
        Num_tel: 'telNo',
        Num_fax: 'faxNo',
        name_commerciale: 'commercialNm',
        Nationalite: 'national',
        affilation_cnss: 'cnssId',
        adresse2: 'addr2',
        code_postale: 'postCd',
        date_redac: 'bizRegYmd',
        num_unique_artisan: 'artisanNo',
        entreprise_entrangere: 'chkRc',
        page: 'hpage',
        identifiantunique: 'bizRegNo',
    };

    constructor(
        private formBuilder: FormBuilder,
        private service: FournisseurService
    ) {
    }

    /*  private createNoRequiredFieldmontant(initialValue = null) {
      return this.formBuilder.control(
        isEmpty(initialValue) ? initialValue : Number(initialValue)
      );
    }*/
    createField(label: keyof any, control: AbstractControl) {
        return {[label]: control};
    }

    create(value?: any) {
        return this.createRequiredField(value);
    }

    createAddForm() {
        return this.formBuilder.group({
            ...this.createField(this.fields.forme_jurdique, this.create()),
            ...this.createField(this.fields.affilation_cnss, this.createcnss()),

            ...this.createField(this.fields.name_commerciale, this.create()),
            ...this.createField(this.fields.categorie, this.create()),
            listCategAct: this.formBuilder.array([this.createItem()]),
            ...this.createField(this.fields.name_soc, this.create()),
            ...this.createField(this.fields.code_postale, this.create()),
            ...this.createField(
                this.fields.Nationalite,
                this.createNoRequiredField()
            ),

            ...this.createField(
                this.fields.identifiantunique,
                this.createidentifiant()
            ),
            ...this.createField(
                this.fields.matricule_fiscale,
                this.creatematricule()
            ),
            ...this.createField(this.fields.nbrempolye, this.createNoRequiredField()),
            ...this.createField(
                this.fields.capitale_social,
                this.createNoRequiredField()
            ),
            ...this.createField(this.fields.date_redac, this.create()),
            ...this.createField(this.fields.open_date, this.create()),
            ...this.createField(
                this.fields.adresse,
                this.createRequiredFieldDisabled()
            ),
            ...this.createField(
                this.fields.code_postale,
                this.createRequiredFieldDisabled()
            ),
            ...this.createField(
                this.fields.entreprise_entrangere,
                this.createEntrprise()
            ),
            ...this.createField(this.fields.adresse2, this.createNoRequiredField()),
            ...this.createField(this.fields.Num_fax, this.createNoRequiredField()),
            ...this.createField(this.fields.Num_tel, this.create()),
            ...this.createField(this.fields.page, this.createNoRequiredField()),
            ...this.createField(
                this.fields.num_unique_artisan,
                this.createNoRequiredField()
            ),
        });
    }

    createRespForm() {
        return this.formBuilder.group({
            umRcvChief: this.formBuilder.group({
                chfNm: [null, Validators.required],
                indRegNo: [null, [Validators.required, CustomValidators.isCin()]],
                mtelNo: [null, Validators.required],
                email: [null, [Validators.required, CustomValidators.emailValidator()]],
                issuedYmd: [null, Validators.required],
            }),
        });
    }

    createItem(): FormGroup {
        return this.formBuilder.group({
            cd: new FormControl(null),
        });
    }

    private createRequiredField(initialValue = null) {
        return this.formBuilder.control(null, [Validators.required]);
    }

    private createidentifiant(initialValue = null) {
        return this.formBuilder.control(initialValue, {
            validators: [Validators.required],

            asyncValidators: [
                CustomValidators.uniqueidentifiantValidator(this.service),
                CustomValidators.taxExistenceValidtor(this.service),
            ],
            updateOn: 'blur',
        });
    }

    private createEntrprise() {
        return this.formBuilder.control('N', [Validators.required]);
    }

    private creatematricule(initialValue = null) {
        return this.formBuilder.control(initialValue, {});
    }

    private createcnss() {
        return this.formBuilder.control(null, {
            validators: [Validators.required, CustomValidators.cnssValidtors()],
            asyncValidators: [
                CustomValidators.uniquecnsstValidator(this.service),
                CustomValidators.cnssExistenceValidtor(this.service),
            ],
            updateOn: 'blur',
        });
    }

    private createNoRequiredField(initialValue = null) {
        return this.formBuilder.control(null);
    }

    private createRequiredFieldDisabled(initialValue = null) {
        return this.formBuilder.control({value: initialValue, disabled: true}, [
            Validators.required,
        ]);
    }
}
